import { PropertySetModule } from "@/services/admin/property-set/modal"
import { PlusOutlined } from "@ant-design/icons"
import { Button, Input, Row, Space, Table } from "antd"
import classNames from "classnames"
import { useMemo, useState } from "react"
import { useOutletContext } from "react-router"
import { AddEditReactionSet } from "./AddEditReactionSet"
import { deleteReactionSet } from "@/services/admin/property-set"
import { Equation } from "@/components/Equation/Equation"

export function PropertySetReactionSets() {
  const {propertySet, refresh} = useOutletContext<{propertySet: PropertySetModule.Modal, refresh: () => void}>();
  const [text, setText] = useState('')

  const filteredData = useMemo(() => {
    if (!text) return propertySet?.reactionSets || []
    return (propertySet?.reactionSets || []).filter(item => item.name.toLowerCase().includes(text.toLowerCase()))
  }, [propertySet?.reactionSets, text])

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Reaction',
      dataIndex: 'reactions',
      key: 'reactions',
      render: (reactions, record) => {
        return reactions.map(r => {
          const reaction: PropertySetModule.Reaction | undefined = propertySet.reactions.find(item => item.id === r.id)
          if (!reaction) return null
          return <div>
            <Equation components={propertySet.components} value={reaction.reactants}/>
            <span className="ml-1">(ATE: {r.ate}K)</span>
          </div>
        })
      }
    },
    {
      title: 'Actions',
      dataIndex: 'Actions',
      key: 'Actions',
      render: (_, record) => {
        return <Space>
          <Button onClick={() => {
            AddEditReactionSet.show({
              propertySet,
              reactionSet: record,
              onSuccess: () => refresh()
            })
          }}>Edit</Button>
          <Button onClick={async () => {
            await deleteReactionSet({setId: propertySet.id, id: record.id})
            refresh()
          }}>Delete</Button>
        </Space>
      }
    },
  ]
  return <div style={{width: '100%'}}>
    <Row justify={'space-between'}>
      <Input
        placeholder='Search by Name'
        style={{ width: 300 }}
        allowClear
        onChange={(event) => {
          setText(event.target.value)
        }}
      />
      <Button type='primary' icon={<PlusOutlined />} onClick={() => {
        AddEditReactionSet.show({
          propertySet,
          onSuccess: () => refresh()
        })
      }} >
        Create
      </Button>
    </Row>
    <div className={classNames('mt-2')}>
      <Table
        bordered
        rowKey={'id'}
        pagination={{ pageSize: 20, hideOnSinglePage: true }}
        size='small'
        columns={columns}
        dataSource={filteredData}
      />
    </div>
  </div>
}